import { AppConfigModel } from '@/models/app/app-config';


/**
 *
 * This App Config serializer is responsible for converting the Raw format to model.
 *
 */
export class AppConfigSerializer {
  private static INSTANCE = new AppConfigSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public appConfigModelSerializer(res: any) {
    const result: AppConfigModel = {
      api_endpoint_url: res.api_endpoint_url,
      capAccessIds: res.CAP_LIBRARY || res.capAccessIds || null,
      includeCap: res.INCLUDE_CAP_LIBRARY || res.includeCap || {},
      shareableAccount: res.SHAREABLE_ACCOUNT || res.shareableAccount,
      LOGO_URL: res.LOGO_URL,
      FAV_ICON: res.FAV_ICON,
      tenantUrl: res.tenantUrl,
      adminUiAppId: res.adminUiAppId,
      S3_BUCKET_ASSETS_BASE_PATH: res.S3_BUCKET_ASSETS_BASE_PATH,
      STATIC_IMAGE_URL: res.STATIC_IMAGE_URL,
      environmentCopy: res.environmentCopy || 'stage',
      loginPageInfo: res.loginPageInfo,
      guestAccount: res.guestAccount,
      guest_account: res.guest_account ? res.guest_account : null,
      podcastCdnUrl: res.podcastCdnUrl ? res.podcastCdnUrl : null,
      podcastNileUrl: res.podcastNileUrl ? res.podcastNileUrl : null,
      bearerToken: res.bearerToken ? res.bearerToken : null,
    };
    return result;
  }
  public appPermissionSerializer(res: any, permission: any) {
    const userRole: any = {
      menus: [],
      pages: {},
    };
    if (permission && permission.length && res) {
      permission.map((pageAccess: any) => {
        Object.keys(res).map((menuPages) => {
          if (!userRole.pages.hasOwnProperty(menuPages)) {
            userRole.pages[menuPages] = [];
          }
          Object.keys(res[menuPages]).map((pages) => {
                if (res[menuPages][pages].indexOf(pageAccess) !== -1) {
                  if (userRole.menus.indexOf(menuPages) === -1
                          && (pages === `${menuPages}-view` || pages === 'all')) {
                    userRole.menus.push(menuPages);
                  }
                  if (userRole.pages[menuPages].indexOf(pages) === -1) {
                     userRole.pages[menuPages].push(pages);
                  }
                }
            });
        });
      });
    }
    // Set Default landing page to facet serach
    userRole.landingPage = '/facet-search';

    // userRole.landingPage = (userRole.menus.indexOf('dashboard') !== -1
    //   ? '/dashboard'
    //   : '/' + (userRole.menus.length ? userRole.menus[0] : 'dashboard'));
    return userRole;
  }


}

export const appConfigSerializer = AppConfigSerializer.instance;
